/**
 * HTMX Setup
 * Configures HTMX and makes it globally available
 */
import htmx from 'htmx.org';

// Make htmx globally available for templates and dynamic content
window.htmx = htmx;

// Swap content on error responses so server-rendered error templates are displayed
htmx.config.responseHandling = [
    { code: "204", swap: false },
    { code: "[23]..", swap: true },
    { code: "[45]..", swap: true, error: true },
];

export { htmx };
